import { gql } from '@apollo/client'

import COURSE_CARD_FRAGMENT from 'src/components/CourseCard/fragments'

export default gql`
  query CoursesCourses(
    $page: Int
    $perPage: Int
    $difficultyLevel: ProductCourseDifficultyLevel
    $length: ProductCourseLength
    $subject: ProductCourseSubject
  ) {
    productCourses(
      difficultyLevel: $difficultyLevel
      length: $length
      page: $page
      perPage: $perPage
      subject: $subject
      sort: { direction: ASC, key: ORDER }
    ) {
      nodes {
        ...CourseCardComponent
      }
      totalCount
      pageInfo {
        hasNextPage
        totalCount
      }
    }
  }

  ${COURSE_CARD_FRAGMENT}
`
